/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetentionOverrideRequest
 */
export interface RetentionOverrideRequest {
    /**
     * Optional number of days to retain after decommission
     * @type {number}
     * @memberof RetentionOverrideRequest
     */
    days?: number;
    /**
     * Optional ISO-8601 timestamp until which to retain (e.g., 2025-12-31T23:59:59Z)
     * @type {string}
     * @memberof RetentionOverrideRequest
     */
    until?: string;
}

/**
 * Check if a given object implements the RetentionOverrideRequest interface.
 */
export function instanceOfRetentionOverrideRequest(value: object): value is RetentionOverrideRequest {
    return true;
}

export function RetentionOverrideRequestFromJSON(json: any): RetentionOverrideRequest {
    return RetentionOverrideRequestFromJSONTyped(json, false);
}

export function RetentionOverrideRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetentionOverrideRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'days': json['days'] == null ? undefined : json['days'],
        'until': json['until'] == null ? undefined : json['until'],
    };
}

export function RetentionOverrideRequestToJSON(json: any): RetentionOverrideRequest {
    return RetentionOverrideRequestToJSONTyped(json, false);
}

export function RetentionOverrideRequestToJSONTyped(value?: RetentionOverrideRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'days': value['days'],
        'until': value['until'],
    };
}

